import { createApiAction } from '@app/packages/api/utils'
import type { ApiAnnouncementsSearchStat } from '@app/packages/api/v2/types/entities'
import type { GetAnnouncementsSearchStatsQuery } from '@app/packages/api/v2/types/params'
import { v2Path } from '@app/packages/api/v2/utils'

export const getAnnouncementsSearchStats = (query: GetAnnouncementsSearchStatsQuery) =>
  createApiAction('getAnnouncementsSearchStats', dispatch =>
    dispatch<{ data: ApiAnnouncementsSearchStat }>({ method: 'GET', endpoint: v2Path('/api/v2/announcements_search_stats', query) })
  )
